import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { categories } from "../../data";

function CategoryCard({ cat, large }) {
  return (
    <Link
      to={`/products#${cat.slug}`}
      data-testid={`category-card-${cat.slug}`}
      className={`group relative block bg-ink-900 overflow-hidden hover-lift ${
        large ? "lg:col-span-2 lg:row-span-1" : ""
      }`}
    >
      <div className={`relative ${large ? "aspect-[16/8]" : "aspect-[4/3]"} overflow-hidden`}>
        <img
          src={cat.image}
          alt={cat.title}
          className="w-full h-full object-cover opacity-40 group-hover:opacity-70 group-hover:scale-105 transition-all duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/60 to-transparent" />
      </div>
      <div className="absolute inset-x-0 bottom-0 p-8 lg:p-10">
        <p className="font-mono text-[10px] tracking-[0.24em] uppercase text-signal-amber mb-3">
          {cat.code} · {cat.short}
        </p>
        <h3 className="h-display text-3xl lg:text-5xl mb-3">{cat.title}</h3>
        <p className="font-mono text-xs text-textmuted leading-relaxed max-w-md mb-5">
          {cat.description}
        </p>
        <span className="inline-flex items-center gap-2 font-mono text-xs tracking-[0.2em] uppercase text-textmain group-hover:text-signal-amber transition-colors">
          Explore <ArrowUpRight size={14} />
        </span>
      </div>
    </Link>
  );
}

export default function CategoriesBento() {
  return (
    <section className="section-padding py-24 lg:py-32" data-testid="categories-section">
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
        <div>
          <p className="overline mb-3">// What we deliver</p>
          <h2 className="h-display text-4xl md:text-6xl max-w-[14ch]">
            Three lines.<br />One engineering standard.
          </h2>
        </div>
        <Link to="/products" className="btn-ghost self-start md:self-end" data-testid="categories-cta">
          Full catalogue <ArrowUpRight size={14} />
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 grid-cells">
        {categories.map((c, i) => (
          <CategoryCard key={c.slug} cat={c} large={i === 0} />
        ))}
      </div>
    </section>
  );
}
